module.exports = "/_next/static/images/e855ae88b1b70699ab0f21c2954a88f6-missions.png";